import React from 'react';

interface NavbarProps {
    session: any;
    totalItemsCount: number;
    flashBasket: boolean;
    isMobileMenuOpen: boolean;
    setIsMobileMenuOpen: (open: boolean) => void;
    onOpenTrackOrders: () => void;
    onOpenBasket: () => void;
    onOpenProfile: () => void;
}

const Navbar: React.FC<NavbarProps> = ({
    session, totalItemsCount, flashBasket, isMobileMenuOpen, setIsMobileMenuOpen,
    onOpenTrackOrders, onOpenBasket, onOpenProfile,
}) => {
    const handleMobileAction = (action: () => void) => {
        action();
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-sm z-50 border-b border-gray-100 px-4 py-4">
            <div className="container mx-auto flex justify-between items-center">
                <div
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="text-3xl md:text-4xl font-bold text-green-600 cursor-pointer select-none whitespace-nowrap"
                    style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}
                >
                    MitiFresh🥭
                </div>

                <div className="hidden md:flex gap-8">
                    <button onClick={() => {window.location.hash = '#/garden'; setTimeout(() => window.scrollTo(0, 0), 100);}} className="text-gray-600 hover:text-green-600 transition-colors font-medium text-base">Visit Garden</button>
                    <button onClick={() => {window.location.hash = '#/dashboard'; setTimeout(() => window.scrollTo(0, 0), 100);}} className="text-gray-600 hover:text-green-600 transition-colors font-medium text-base">Add Tree</button>
                    <button onClick={() => document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' })} className="text-gray-600 hover:text-green-600 transition-colors font-medium text-base">Join Updates</button>
                </div>

                <div className="flex items-center gap-4">
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-gray-100">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                    <button onClick={onOpenTrackOrders} className="hidden md:block p-2 rounded-full hover:bg-gray-100 text-gray-700 transition-all" title="Track Your Orders">
                        <svg className="w-6 h-6 text-green-600 hover:scale-105 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.3}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-14L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                    </button>
                    <button onClick={onOpenBasket} className={`hidden md:block relative p-2 rounded-full hover:bg-gray-100 text-gray-700 transition-all ${flashBasket ? 'scale-125 text-green-600' : ''}`}>
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                            <path d="M7 10 L12 5 L17 10" /><path d="M2 10h20" /><path d="M3.5 10l1.5 9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2l1.5-9" /><circle cx="12" cy="15.5" r="1.5" />
                        </svg>
                        {totalItemsCount > 0 && <span className="absolute -top-1 -right-1 bg-green-500 text-white font-bold text-xs w-5 h-5 rounded-full flex items-center justify-center shadow-md">{totalItemsCount}</span>}
                    </button>
                    <button onClick={onOpenProfile} className="hidden md:flex w-10 h-10 rounded-full bg-green-100 border border-green-200 items-center justify-center font-bold text-green-700 hover:scale-105 transition-transform">
                        {session?.user?.email?.substring(0, 2).toUpperCase()}
                    </button>
                </div>
            </div>
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-100 shadow-lg flex flex-col p-4">
                    <button onClick={() => { window.location.hash = '#/garden'; setIsMobileMenuOpen(false); }} className="text-left py-3">Visit Garden</button>
                    <button onClick={() => { window.location.hash = '#/dashboard'; setIsMobileMenuOpen(false); }} className="text-left py-3">Add Tree</button>
                    <button onClick={() => { document.getElementById('waitlist')?.scrollIntoView(); setIsMobileMenuOpen(false); }} className="text-left py-3">Join Updates</button>
                    <hr className="my-2" />
                    <button onClick={() => handleMobileAction(onOpenTrackOrders)} className="text-left py-3">Track Orders</button>
                    <button onClick={() => handleMobileAction(onOpenBasket)} className="text-left py-3">Basket ({totalItemsCount})</button>
                    <button onClick={() => handleMobileAction(onOpenProfile)} className="text-left py-3">Profile</button>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
